// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2, CustomCheckBox,
  CustomDropdownFilter,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";
import CheckMarks from "../../../DashboardScreen/components/CheckMarks";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestDriver, setRequestDriver } = useContext(Context.DriverScreen);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestDriver?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestDriver?.filters?.province?.Code,
      })
  );
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const getAllCompanyForAdmin = useQuery(
    [values.useQueryKeys.getAllCompany],
    () => api.post.administrator.getAllCompany({}),
    { enabled: userType === "ADMIN" }
  );
  const getAllCompanyForSuperAgent = useQuery(
    [values.useQueryKeys.getAllCompany, "super-agent"],
    () => api.post.superAgent.findCompany({}),
    { enabled: userType === "SUPER_AGENT_SCHOOL" }
  );

  const getAllCompany =
    userType === "ADMIN" ? getAllCompanyForAdmin : getAllCompanyForSuperAgent;

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================
  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  const { t } = useTranslation();

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        {(userType === "ADMIN" || userType === "COMPANY") && (
          <>
            <p className="filter-labels">{t("province")}:</p>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder={t("selectProvince")}
              isLoading={getAllProvince.isLoading}
            />
            <p className="filter-labels">{t("city")}:</p>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,

                    city: event,
                  },
                })
              }
              placeHolder={t("selectCity")}
              isLoading={getAllCity.isLoading}
            />
          </>
        )}
        {userType !== "COMPANY" && (
          <>
            <p className="filter-labels">{t("company")}:</p>
            <CustomDropdownSearch
              isSearch
              items={companyInformationWithCompanyName}
              itemName="companyName"
              defaultItem={requestDriver?.filters?.company}
              onSelectItem={(event: ICompanyItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,

                    company: event,
                  },
                })
              }
              placeHolder={t("selectCompany")}
            />
          </>
        )}
        <p className="filter-labels">{t("gender")}:</p>
        <CustomDropdownSearch
          items={gender}
          itemName="name"
          placeHolder={t("selectGender")}
          defaultItem={requestDriver?.filters?.gender}
          onSelectItem={(event: ICompanyItem) =>
            setRequestDriver!({
              ...requestDriver,
              filters: {
                ...requestDriver?.filters,
                gender: event,
              },
            })
          }
        />{" "}
        <p className="filter-labels">{t("maritalStatus")}:</p>
        <CustomDropdownSearch
          items={marital}
          itemName="name"
          placeHolder={t("selectMaritalStatus")}
          defaultItem={requestDriver?.filters?.marital}
          onSelectItem={(event: ICompanyItem) =>
            setRequestDriver!({
              ...requestDriver,
              filters: {
                ...requestDriver?.filters,

                marital: event,
              },
            })
          }
        />
        <CustomCheckBox
          label={'شماره برچسب'}
          isChecked={false}
          onChecked={() => setRequestDriver &&setRequestDriver({...requestDriver, filters: {...requestDriver?.filters} })}
        />
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestDriver!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  {name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default FilterAgent;
